import { Collapse, ConfigProvider } from 'antd'
import React from 'react'

const MyCollapse = ({ items, onChange, ...rest }) => {
  return (
    <ConfigProvider
        theme={{
            components: {
                Collapse: {
                    colorBorder: 'none',
                },
            },
        }}
    >
        <Collapse items={items} defaultActiveKey={['1']} onChange={onChange} expandIconPosition='end' bordered={false} {...rest} />
    </ConfigProvider>
  )
}

export default MyCollapse
